import type { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/Button'
import { Alert } from '@/components/ui/misc'
import { useSessionStore } from '../sessionStore'
import { AuthShell } from '../components/AuthShell'

/* SESSION_REPLACED gets a dedicated screen, never a silent redirect.

   One active session per student is a deliberate anti-cheating rule. When it
   fires, the student is often mid-exam, and being dumped at a login form with
   no explanation reads as "the platform lost my test". Saying plainly what
   happened — and that the attempt is safe — is the whole point. */

export function SessionReplacedScreen(): ReactNode {
  const navigate = useNavigate()
  const signOut = useSessionStore((state) => state.signOut)

  return (
    <AuthShell title="You signed in somewhere else">
      <Alert tone="warning" title="This session was ended">
        <p>
          Your account was signed in on another device or browser. For exam integrity only one
          session can be active at a time, so this one was closed.
        </p>
        <p style={{ marginBottom: 0 }}>
          <strong>Any test you had in progress is safe.</strong> Sign in again to resume it — your
          answers and remaining time are stored on our side.
        </p>
      </Alert>

      <div style={{ marginTop: 'var(--s-5)' }}>
        <Button
          size="lg"
          fullWidth
          onClick={() => {
            signOut()
            navigate('/login', { replace: true })
          }}
        >
          Sign in again
        </Button>
      </div>
    </AuthShell>
  )
}
